import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22index.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./Microgramma-D-Bold-Extended.ttf%22}],%22variableName%22:%22microgramma%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'microgramma', 'microgramma Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
